import { Component, EventEmitter, OnInit } from '@angular/core';
import { DropdownOption, DropdownConfig } from 'src/app/components/custom-dropdown/custom-dropdown.component';
import { FaqBuilder, InfoDropdown } from 'src/app/components/faq/faq.component';
import { FeatureType } from 'src/app/components/featured-plates/featured-plates.component';
import { SidebarFilterConfig, SidebarFilterGroup, SidebarFilter } from 'src/app/components/side-bar-filters/side-bar-filters.component';
import { StickyConfig, StickyLinkGroup, StickyLink } from 'src/app/components/sticky-tabs/sticky-tabs.component';
import { HttpLoadingResp } from 'src/app/models/httpLoadingResp';
import { Registration } from 'src/app/models/registration';
import { RegistrationService } from 'src/app/services/registration-service';
import { SearchReqResponse, SearchService } from 'src/app/services/search-service';
import { SearchFilters } from '../search-results-page/search-results-page.component';
import GlobalFaqs from "../../global-faqs";

@Component({
  selector: 'pla-under-one-hundred',
  templateUrl: './under-one-hundred.component.html',
  styleUrls: ['./under-one-hundred.component.scss']
})
export class UnderOneHundredComponent implements OnInit {

  public searchTrigger: EventEmitter<void> = new EventEmitter<void>();
  public stickyLinkConfig: StickyConfig = new StickyConfig(
    [
      new StickyLinkGroup([
        new StickyLink('Results', 'results', true),
        new StickyLink('Q&As', 'faq', false),
      ].filter(x => x != null)),
    ],
    new EventEmitter<void>()
  );
  public termSorting: DropdownOption = new DropdownOption('LOW-TO-HIGH', 'Price Low to High');
  public mobileFilterToggle: EventEmitter<boolean> = new EventEmitter<boolean>();
  public sortTrigger: EventEmitter<void> = new EventEmitter<void>();
  public filterChange: EventEmitter<SearchFilters> = new EventEmitter<SearchFilters>();
  public filterUpdate: EventEmitter<SidebarFilterConfig<any>> =
    new EventEmitter<SidebarFilterConfig<any>>();
  public sortDropdownConfig: DropdownConfig = new DropdownConfig('Sort By', 'swap_vert', [
    new DropdownOption('A-Z', 'A-Z'),
    new DropdownOption('Z-A', 'Z-A'),
    new DropdownOption('LOW-TO-HIGH', 'Price Low to High'),
    new DropdownOption('HIGH-TO-LOW', 'Price High to Low')
  ], {
    initialValue: this.termSorting
  });

  public searchFilters: SidebarFilterConfig<SearchFilters> = new SidebarFilterConfig<SearchFilters>(
    [
      new SidebarFilterGroup('Sort By', [
        new SidebarFilter('sort', 'Sort By', 'sortBy', {
          selectConfig: this.sortDropdownConfig
        })
      ], { visible: true, customClass: 'd-block d-lg-none' }),
    ], this.filterChange);

  public raFeatured = new FeatureType('Recently Added', 'recently-added');
  private allResults: Registration[] = [];
  public results: HttpLoadingResp<SearchReqResponse> = new HttpLoadingResp(true, undefined);
  public faq: InfoDropdown[] = GlobalFaqs.GetFaqsByKey("Sub £200");

  constructor(
    private searchService: SearchService,
    private registrationService: RegistrationService
  ) {
    this.filterChange.subscribe((_: SearchFilters) => {
      this.TermSortChange(this.sortDropdownConfig.options.find(o => o.value === _.sortBy), "");
    });
  }

  ngOnInit(): void {
    this.Search();
  }

  public filterSearchResults(input: string): void {
    const filteredResults = [...this.allResults].filter(r => r.registration.indexOf(input) > -1);
    this.results.Update(false, new SearchReqResponse('sub-200', filteredResults));
    this.TermSortChange(this.termSorting, "");
  }

  private Search(): void {
    this.searchService.getSub200((_: Registration[]) => {
      this.allResults = this.registrationService.formatRegistrations(_);
      this.results.Update(false, new SearchReqResponse('sub-200', this.allResults));

      this.filterUpdate.emit(this.searchFilters);
      this.TermSortChange(this.termSorting, "");
    })
  }

  public TermSortChange(e: DropdownOption, key: string): void {
    this.termSorting = e;
    var sortedData = [];
    if (this.termSorting.value === 'A-Z') sortedData = this.results.data.registrations.sort((a, b) => a.registration.localeCompare(b.registration));
    else if (this.termSorting.value === 'Z-A') sortedData = this.results.data.registrations.sort((a, b) => b.registration.localeCompare(a.registration));
    else if (this.termSorting.value === 'HIGH-TO-LOW') sortedData = this.results.data.registrations.sort((a, b) => b.price - a.price);
    else if (this.termSorting.value === 'LOW-TO-HIGH') sortedData = this.results.data.registrations.sort((a, b) => a.price - b.price);

    this.results.Update(false, new SearchReqResponse('sub-200', this.registrationService.formatRegistrations(sortedData)));
  }
}
